import initialState from '../store/initialstate'
import C_BANNER from  '../constants/banner';

export default (state = initialState().banner, action = null) => {
    switch(action.type){
        case C_BANNER.SET_USER_BANNER:
            return state.set(C_BANNER.USER_BANNER, action.payload);
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./reducers/banner.js